<script setup lang="ts">
defineProps<{
  title: string
  items: string[]
  icon: string
}>()
</script>

<template>
  <div class="space-y-2">
    <h3 class="font-semibold text-gray-900 flex items-center gap-2">
      <Icon
        :name="icon"
        class="w-5 h-5 text-emerald-600"
      />
      {{ title }}
    </h3>
    <ul class="space-y-1">
      <li
        v-for="(item, idx) in items"
        :key="idx"
        class="text-gray-700 text-sm flex items-start gap-2"
      >
        <Icon
          name="i-heroicons-check"
          class="w-4 h-4 text-emerald-600 flex-shrink-0 mt-0.5"
        />
        <span class="flex-1">{{ item }}</span>
      </li>
    </ul>
  </div>
</template>
